import { Backdrop } from "@mui/material";
import TableTopBar from "../modal/tableTopBar";
import Lottiefy from "../../atom/lottie/lottie";
import FadeIn from "react-fade-in";
import Table from "../../atom/table";
import PaginationButtons from "../../atom/pagination";
import { EditPencilIcon } from "../../utils/icons/defaultIcons";
import { useEffect, useState } from "react";
import {
  get_All_DCID,
  getExtensionsData,
  getExtensionTabCSV,
  getToken,
  updateExtensionStatus,
  updateExtensionToggle,
} from "../../services/api";
import * as loaderLottie from "../../utils/lottie/loaderLottie.json";
import TenantExtensionModal from "../modal/tenantExtensionModal";
import React from "react";
import { getENVData } from "../../config/environment";
import {
  actualDataToMapData,
  downloadFileFromURL,
} from "../../services/utilities";
import { useSelector } from "react-redux";
import Notification from "../../atom/Notification";
import Modal from "../../atom/modal";
import ThemedButton from "../../atom/ThemedButton/themedButton";
import ComponentMap from "../../atom/componentmap";

function TenantExtensions() {
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [pageCount, setPageCount] = useState<number>(0);
  const [tableData, setTableData] = useState<any>([]);
  const [loader, setLoader] = useState<boolean>(false);
  const [perPage, setPerPage] = useState<number>(25);
  const [sort, setSort] = useState<any>({
    key: "extension",
    order: "ASC",
  });
  const [resultNotFound, setResultNotFound] = useState<boolean>(false);
  const [searchtext, setSearchText] = useState<any>("");
  const [editExtensionModal, setEditExtensionModal] = useState<boolean>(false);
  const [key, setKey] = React.useState(0);
  const [rowData, setRowData] = useState<any>(null);
  const [handleKeyPress, setHandleKeyPress] = useState<boolean>(true);
  const [csvDownload, setCsvDownload] = useState<boolean>(false);
  const [extensionId, setExtensionId] = useState<string>("");
  const [dcidDropdown, setDcidDropdown] = useState<boolean>(false);
  const [buttonLoader, setButtonLoader] = useState<boolean>(false);

  const id = getToken();
  const token = useSelector((state: any) => state.auth.token);

  const [tableTitles, setTableTitles] = useState<any>([
    {
      key: "extension",
      title: "Extension",
      hide: { status: true, default: true },
      sort: { direction: "asc", active: true },
    },
    {
      key: "first_name",
      title: "First Name",
      hide: { status: true, default: false },
      sort: { direction: "asc", active: false },
    },
    {
      key: "last_name",
      title: "Last Name",
      hide: { status: true, default: false },
      sort: { direction: "asc", active: false },
    },
    {
      key: "dcid_list_name",
      title: "DCID Name",
      type: "link",
      hide: { status: true, default: true },
      sort: { direction: "asc", active: false },
    },
    {
      key: "extension_status",
      title: "Features",
      hide: { status: true, default: false },
    },
    {
      key: "action_button",
      title: "",
      type: "actionIcon",
      class: "",
      icon: <EditPencilIcon />,
      action: {
        title: "Edit",
        command: "edit",
        action: "click",
      },
    },
  ]);

  const [toggleDropdown, setToggleDropdown] = useState<any>([
    {
      title: "Supervise All",
      key: "monitor_all",
      checked: false,
    },
    {
      title: "Record All",
      key: "record_all",
      checked: false,
    },
    // {
    //   title: "Time Zone Restriction for All",
    //   key: "time_zone",
    //   checked: false,
    // },
  ]);

  const [dcidList, setDcidList] = useState<any>([
    {
      title: "DCID",
      name: "name",
      value: "",
      // disabled: false,
      type: "multiselectdropdown",
      displayProps: {
        label: "name",
        value: "name",
      },
      childrens: [],
      hidden: false,
      errormessage: "Select a DCID",
    },
  ]);

  const getExtentions = (page: number) => {
    setPageNumber(page);
    onHandleSearch({ pageNumber: page });
  };
  const onHandleSearch: any = (options: {
    limit?: number;
    searchtext?: string;
    pageNumber?: number;
    sort_column?: string;
    sort_direction?: string;
  }) => {
    setLoader(true);
    getExtensionsData(
      {
        limit: options?.limit || perPage,
        pageId: options?.pageNumber || pageNumber,
        sort_column: options?.sort_column || sort.key,
        sort_direction: options?.sort_direction || sort.order,
        searchtext:
          options?.searchtext === undefined
            ? searchtext
            : options?.searchtext === ""
              ? ""
              : options?.searchtext,
      },
      id,
    ).then((resultData: any) => {
      if (!resultData?.success || resultData?.data?.data?.length === 0) {
        setLoader(false);
        setResultNotFound(true);
        setTableData([]);
      } else {
        setResultNotFound(false);
        const tableDataClone = [...tableData];
        tableDataClone.map((node: any) => {
          return node?.dcid_list_name === "undefined"
            ? "Add DCID"
            : node?.dcid_list_name;
        });
        setTableData(tableDataClone);
      }
      if (resultData?.data?.data?.length > 0) {
        const Array: any = [];
        Array.push(resultData?.data?.data);
        Array[0][0].monitor_all = resultData?.data.monitor_all;
        Array[0][0].record_all = resultData?.data.record_all;
        Array[0][0].time_zone = resultData?.data.time_zone;
        const result: any = Array[0] || [];
        setPageCount(resultData.data.total_count);

        const updatedArray = result.map((item: any) => ({
          ...item,
          dcid_list_name:
            item.dcid_list_name === "undefined"
              ? "Add DCID "
              : item.dcid_list_name,
        }));
        const statusFilteredArray = updatedArray.map((item: any) => {
          const statuses = [];
          if (item?.is_monitorable) statuses.push("Supervisor Tools");
          if (item?.is_recordable) statuses.push("Recording");
          //   if (item?.time_zone_restriction) statuses.push("Timezone Restricted");
          //   if (item?.is_sms_enabled) statuses.push("SMS Enabled");
          //   if (item?.speech_analytics_enabled) statuses.push("Speech Analytics");
          if (statuses.length === 0) statuses.push("--");
          return { ...item, extension_status: statuses.join(", ") };
        });

        setTableData(statusFilteredArray);

        setToggleDropdown(
          toggleDropdown.map((item: any) => ({
            ...item,
            checked: resultData?.data[item.key] ?? false, // default to false if key is missing
          })),
        );

        setLoader(false);
      }
    });
  };

  const handleEditExtension = (data: any) => {
    setEditExtensionModal(true);
    setRowData(data);
  };

  const handleCSVDownload = () => {
    console.log(sort.key, "sort.key");
    setCsvDownload(true);

    let payload = {
      sort_column: sort.key,
      sort_direction: sort.order,
    };
    //vaspian-dev.vaspian.com/v2/tenants/ffff52e9-147e-4e29-ab98-55405af1b89c/
    https: getExtensionTabCSV(id, payload).then((result: any) => {
      if (result.data) {
        const baseURL = `${
          getENVData().baseURL
        }/tenants/${id}/extensions/download/csv/`;
        const url = `${baseURL}${result?.data.path.replace(
          "/opt/msa_provisioner/var/tmp/",
          "",
        )}`;
        downloadFileFromURL(url, "Extensions", token)
          .then((result: any) => {
            if (!result) {
              console.error("Download Failed");
            }
            setCsvDownload(false);
          })
          .catch((error: any) => {
            setCsvDownload(false);
            console.error("Download Failed");
          });
      } else {
        setCsvDownload(false);
        console.error("Download Failed");
      }
    });
  };

  const handleTableTitle = (data: any) => {
    setTableTitles(data);
    console.log("data", data);

    var status: any = {};
    data
      .filter((node: any) => node?.hide?.status !== undefined)
      .map((node: any) => {
        status[node.key] = node.hide.status;
      });
    window.sessionStorage.setItem(
      "tenantExtensionsTabTableTitles",
      JSON.stringify(status),
    );
  };

  const get_All_Lists = (pgNum: number, loader: boolean = true) => {
    setPageNumber(pgNum);
    onHandleSearch({ start: pgNum, loader });
  };

  const handleToggleChange = (data: any) => {
    const payload = {
      [data.key]: !data.checked,
    };
    updateExtensionToggle(id, data?.key, payload).then((result: any) => {
      if (!result.success) {
        let msg = result?.message;
        Notification(
          "Failed",
          msg?.charAt(0).toUpperCase() + msg.slice(1),
          "danger",
        );
      } else {
        getExtentions(pageNumber);
        setToggleDropdown(
          toggleDropdown.map((node: any) => {
            if (node.key === data.key) {
              return { ...node, checked: !node.checked };
            }
            return node;
          }),
        );
      }
    });
  };

  const handleChange = (pNUm: number) => {
    get_All_Lists(pNUm);
    setPageNumber(pNUm);
  };

  const handlePerPage = (value: any) => {
    value = parseInt(value);
    setPerPage(value);
    setPageNumber(1);
    onHandleSearch({ limit: value, start: 1 });
  };

  const handleSearch = (data: string) => {
    setPageNumber(1);
    setSearchText(data);
    onHandleSearch({ searchtext: data, pageNumber: 1, limit: perPage });
  };

  const onHandleSort = (node: any, orderBy: string) => {
    setSort({ key: node.key, order: orderBy });
    onHandleSearch({ sort_column: node.key, sort_direction: orderBy });
  };

  const onHandleDCID_Name = (data: any) => {
    setExtensionId(data?.uuid);

    const selectedvalue = {
      name: data?.dcid_list_name,
    };

    // Add Unassign as the first dropdown child
    const unassignChild = {
      uuid: "Unassign",
      name: "Unassign",
    };

    // Clone list
    const updatedList = [...dcidList];

    // Inject Unassign at top of childrens
    updatedList[0].childrens = [unassignChild, ...updatedList[0].childrens];

    // Apply mapping for selected state
    setDcidList(actualDataToMapData(updatedList, selectedvalue));

    // Load dynamic plans from API
    get_All_DCID(id).then((result: any) => {
      if (!result.success) {
        Notification(
          "Failed",
          result?.message || "Failed to fetch DCID",
          "danger",
        );
      } else {
        const plans = result?.data.items;
        const final = [...dcidList];
        final[0].childrens = [
          unassignChild,
          ...plans, //  real DCIDs
        ];

        setDcidList(final);
        setDcidDropdown(true);
      }
    });
  };

  const onHandleSelect = (data: any) => {
    console.log("data", data);

    if (data.name === "Add DCID" || data.name === null || undefined) {
      Notification("Failed", "Select any DCID", "danger");
    } else {
      const payload = {
        dcid_list_id: data.name.uuid,
      };
      updateExtensionStatus(payload, id, extensionId).then((result: any) => {
        if (!result.success) {
          Notification(
            "Failed",
            `${
              result?.message ? result?.message : "Oops! Something went wrong"
            }`,
            "danger",
          );
        } else {
          Notification("Success", "DCID name added successfully", "success");
        }
      });
      getExtentions(pageNumber);
      setDcidDropdown(false);
    }
  };

  const onCloseModal = () => {
    setDcidDropdown(false);
  };

  const actionHandler = (action: string, data: any, key: any) => {
    console.log("action", action);
    const actionsMap: any = {
      edit: handleEditExtension,
      link: onHandleDCID_Name,
    };
    const act = actionsMap[action];
    if (act) {
      act(data, key);
    } else {
      console.log("actionHandler Error");
    }
  };

  useEffect(() => {
    getExtentions(1);
    // table title storage
    const local: any =
      window.sessionStorage.getItem("tenantExtensionsTabTableTitles") || null;
    const result = JSON.parse(local);
    // debugger
    if (result) {
      var data = [...tableTitles];
      data.map((node: any) => {
        if (result[node.key] !== undefined) {
          if (node.hide) {
            node.hide.status = result[node.key];
          }
        }
      });
      setTableTitles(data);
    }
  }, [key]);
  return (
    <div
      data-testid="tenantExtensions"
      className=" h-full py-3 flex relative gap-2.5 rounded-md"
    >
      {dcidDropdown && (
        <Modal closeEvent={onCloseModal} title={"DCID Name"}>
          <ComponentMap data={dcidList} setData={setDcidList} />
          <div className="text-right sm:w-[350px] md:w-[500px] mt-8">
            <ThemedButton
              children={"Cancel"}
              icon="custom"
              theme="secondary"
              click={onCloseModal}
            />
            <ThemedButton
              children={"Select"}
              icon="custom"
              theme="primary"
              click={onHandleSelect}
              loading={buttonLoader}
              valiData={dcidList}
              change={setDcidList}
            />
          </div>
        </Modal>
      )}
      <Backdrop className="!z-[99999999999]" open={loader}>
        <Lottiefy loop={true} json={loaderLottie} height={100} width={100} />
      </Backdrop>

      {editExtensionModal && (
        <TenantExtensionModal
          editExtensionModal={editExtensionModal}
          setEditExtensionModal={setEditExtensionModal}
          tableData={tableData}
          rowData={rowData}
          setKey={setKey}
          onSubmit={() => {
            setEditExtensionModal(false);
            setKey((prev) => prev + 1); // To re-render
          }}
        />
      )}

      <div className=" h-[calc(100vh-125px)] w-[calc(100vw-125px)] overflow-hidden min-w-max rounded-md bg-[#fff]">
        <FadeIn>
          <div className="pt-3">
            <TableTopBar
              title={"Extensions"}
              button={true}
              search={true}
              searchtext={searchtext}
              setSearchText={setSearchText}
              handleSearch={handleSearch}
              handleKeyPress={handleKeyPress}
              setHandleKeyPress={setHandleKeyPress}
              CSV={true}
              handleCSVDownload={handleCSVDownload}
              csvDownload={csvDownload}
              showDropdownValues={tableTitles}
              setHideDropdownValues={handleTableTitle}
              toggleDropdown={toggleDropdown}
              handleToggleChange={handleToggleChange}
            />
          </div>

          <Table
            tableTitles={tableTitles}
            setTableTitles={setTableTitles}
            tableData={tableData}
            setTableData={setTableData}
            // button={true}
            actionHandler={actionHandler}
            onHandleSort={onHandleSort}
            buttonIndex={4}
            buttonText1={"manage"}
            width={"w-[calc(100vw-122px)] overflow-auto"}
            scrollHeight={"h-[calc(100vh-280px)] overflow-y-auto"}
            permission={"provision.users.put"}
            actions={true}
            resultNotFound={resultNotFound}
          />

          {!resultNotFound && tableData.length > 0 && (
            <PaginationButtons
              pageNumber={pageNumber}
              handleChange={handleChange}
              pageCount={pageCount}
              perPage={perPage}
              handlePerPage={handlePerPage}
              enableAll={true}
            />
          )}
        </FadeIn>
      </div>
    </div>
  );
}
export default TenantExtensions;
